// Gedeelde uitlog-stappen: de uitlogknop en een verlopen sessie doen hetzelfde.
// storeUser bewaart user_data automatisch in APP_USER, dus het token verdwijnt
// daarmee ook uit de browser.
export function logoutUser(stores) {
    const { storeUser, storeAuth, storeOrder, storeUi, storeWishlist } = stores;

    storeUser.resetUserData();
    storeAuth.setLogoutState();
    storeUser.setLogoutState();
    storeUser.setLoginState(false);
    storeOrder.resetOrderData(false);
    storeOrder.retrieveShoppingCartFromLS();
    storeOrder.resetOrderSettings('discounts_overruled', 0);
    storeUi.setUseCase("inshop");
    storeUi.setReturnState("");
    storeUi.setPartnerCode(0);
    storeWishlist.retrieveWishlist();
    storeUi.setFeatureAll(false);
}
